'use strict';

module.exports = {
    getTrackingLabel: function(element, departureOrArrival) {
        var segmentType = departureOrArrival.toLocaleLowerCase();
        var selectedElement = element.geoNodeId === 0 ? 'anywhere' : calculateSelectedElement(element);

        return 'picker:' + segmentType + '_sel:' + selectedElement;
    },
};

function calculateMatchType(element) {
    var matchType = element.matchType.toLowerCase(); // iata_code, airport, region, city, city2, country
    return matchType === 'nearest' ? 'city2' : matchType;
}

function calculateItemLevel(element) {
    var isMainItemWithoutRelated = element.itemLevel === 'mainItem' && element.numRelatedLocations === 1;
    var isNearestOnlyOption = element.matchType === 'NEAREST' && element.numNearestAirports === 1;
    return (isMainItemWithoutRelated || isNearestOnlyOption) ? 'only' : 'all';
}

function calculateSelectedElement(element) {
    var itemType = element.geoNodeType.toLowerCase(); // city, airport, iata_code
    var matchType = calculateMatchType(element);
    var itemLevel = calculateItemLevel(element);
    return itemLevel + '_' + itemType + '_match:' + matchType;
}
